"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const ModalFooter = (props) => {
    const { children } = props;
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)), children));
};
exports.default = withJourney_1.default('j-modal-footer', ModalFooter);
